export default __webpack_public_path__ + "static/media/EG_Zoom-4.05bc5ad8.wav";